/**
 * Registered in dbt-cloud's tenant/admin web-event router (VIS-1539). The tenant models allowlist
 * `miniapp` and the admin models denylist it, so an unregistered value is not dropped — it is
 * counted as admin activity.
 */
export const TRACKING_APP = 'activity_center_miniapp' as const;

/** `element_name` is MACRO_CASE; property keys are snake_case. Both conventions come from miniapp-content. */
export const TRACKING_ELEMENTS = {
  SEGMENT_TAB: 'ACTIVITY_SEGMENT_TAB',
  FILTER_CHIP: 'ACTIVITY_FILTER_CHIP',
  TILE: 'ACTIVITY_TILE',
  TILE_CTA: 'ACTIVITY_TILE_CTA',
  DETAILS_CTA: 'ACTIVITY_DETAILS_CTA',
  EMPTY_CTA: 'ACTIVITY_EMPTY_CTA',
  CREATE_CTA: 'ACTIVITY_CREATE_CTA',
  CANCEL_SUBMIT: 'ACTIVITY_CANCEL_SUBMIT',
  RATING_STAR_CLICK: 'ACTIVITY_RATING_STAR_CLICK',
  RATING_COMMENT_SUBMIT: 'ACTIVITY_RATING_COMMENT_SUBMIT',
  PULL_REFRESH: 'ACTIVITY_PULL_REFRESH',
} as const;

export type TrackingElement = (typeof TRACKING_ELEMENTS)[keyof typeof TRACKING_ELEMENTS];

export const OPEN_MODES = {
  IN_APP: 'in_app',
  DEEPLINK: 'deeplink',
  MODAL: 'modal',
} as const;

export type OpenMode = (typeof OPEN_MODES)[keyof typeof OPEN_MODES];

export const CTA_TYPES = {
  BOOK_AGAIN: 'book_again',
  CANCEL: 'cancel',
  CHECK_IN: 'check_in',
  VIEW_RESOURCE: 'view_resource',
  VIEW_EVENT: 'view_event',
} as const;

export type CtaType = (typeof CTA_TYPES)[keyof typeof CTA_TYPES];
